/* AthleteSwap Hilfe — Volltextsuche über die vorformulierten Fragen.
   Port von lib/hilfe.ts hilfeSuchen(), hier ohne eigenes Datenmodell: die
   Suche liest direkt die bereits gerenderten Fragen-Links aus dem
   Themen-Raster weiter unten auf der Seite — eine Quelle der Wahrheit,
   kein doppelt gepflegtes JSON. */
(function () {
  function init(form) {
    var input = form.querySelector('input[type="search"]');
    var ergebnisBox = document.querySelector('[data-as-hilfe-treffer]');
    var kontaktMail = form.getAttribute('data-kontakt-mail') || 'info@athleteswap.com';
    if (!input || !ergebnisBox) return;

    function suchen(begriff) {
      var q = begriff.trim().toLowerCase();
      if (!q) {
        ergebnisBox.innerHTML = '';
        ergebnisBox.hidden = true;
        return;
      }

      var links = document.querySelectorAll('[data-hilfe-frage]');
      var treffer = [];
      var gesehen = {};
      links.forEach(function (a) {
        var thema = a.closest('[data-hilfe-thema]');
        var themaTitel = thema ? thema.getAttribute('data-hilfe-thema') : '';
        var text = a.textContent.trim();
        var passt = text.toLowerCase().indexOf(q) !== -1 || themaTitel.toLowerCase().indexOf(q) !== -1;
        var schluessel = a.getAttribute('href') + '|' + text;
        if (passt && !gesehen[schluessel]) {
          gesehen[schluessel] = true;
          treffer.push({ text: text, href: a.getAttribute('href') });
        }
      });

      ergebnisBox.hidden = false;
      if (treffer.length === 0) {
        ergebnisBox.innerHTML =
          '<p class="as-hilfe-such-leer">Nichts gefunden. Schreib uns direkt an <a href="mailto:' +
          kontaktMail +
          '">' +
          kontaktMail +
          '</a>.</p>';
        return;
      }

      var html = '<ul class="as-hilfe-suchtreffer">';
      treffer.forEach(function (t) {
        html += '<li><a href="' + t.href + '">' + t.text.replace(/&/g, '&amp;').replace(/</g, '&lt;') + '</a></li>';
      });
      html += '</ul>';
      ergebnisBox.innerHTML = html;
    }

    form.addEventListener('submit', function (e) {
      e.preventDefault();
      suchen(input.value);
    });
    input.addEventListener('input', function () {
      suchen(input.value);
    });

    if (input.value) suchen(input.value);
  }

  function initAll() {
    document.querySelectorAll('[data-as-hilfe-suche]:not([data-as-hilfe-suche-init])').forEach(function (form) {
      form.setAttribute('data-as-hilfe-suche-init', '');
      init(form);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }
})();
